import { Component, ViewEncapsulation, Input, inject } from '@angular/core';
import {
  faqListLandingMock,
  faqListResumeMock
} from '@App/modules/affiliate-flow/mock/affiliate-invite.mock';
import { LandingTypeEnum } from '@App/common/enums';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { UserCommonApiService } from '@App/common/services';

@Component({
  selector: 'app-faq',
  imports: [CommonModule, RouterLink],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent {
  @Input() isMobile = false;
  faqItems: any;
  private userCommonService = inject(UserCommonApiService);
  private router = inject(Router);

  constructor() {}

  @Input() get landingType(): LandingTypeEnum {
    return this.faqItems;
  }

  set landingType(value: LandingTypeEnum) {
    this.faqItems =
      value === LandingTypeEnum.RESUME ? faqListResumeMock : faqListLandingMock;
  }

  toggleFAQ(index: number) {
    this.faqItems[index].open = !this.faqItems[index].open;
  }

  onFaqLinkClick(link: { action?: string; route?: string }) {
    if (link.action === 'contact-sales') {
      this.userCommonService.openSupportWindow(0);
    } else if (link.route) {
      this.router.navigate([link.route]);
    }
  }
}
